if($('#newsWrapper').length){
    $('#newsWrapper .news-item').each(function() {
        $(this).find('.text').append('<a href="'+$(this).find('.title').attr('href')+'" class="absolutePosition"></a>')
    });
}


if($('.in-recenze-od-nasich-zakaznic').length){
    $('.news-item-detail .text').before('<div class="flexContent"><div class="left"><img src="'+$('span[itemprop="image"] meta[itemprop="url"]').attr('content')+'" alt="'+$('h1[itemprop="headline"]').text().trim()+'"></div><div class="right"><div class="h1">'+$('h1[itemprop="headline"]').text().trim()+'</div><div class="textInnerWrap"></div></div></div>')
    $('.flexContent .right .textInnerWrap').append($('.news-item-detail .text>p')) 
    $('.flexContent .right').append($('.news-item-detail .text>blockquote'))
}

if($('.type-posts-listing.in-prodejny').length){
    $('a.title').each(function() {
        var href = $(this).attr('href');
        if (map[href]) {
            $(this).closest('.news-item').find('.text').attr('style', 'background-image:url("' + map[href] + '")');
        }
    });
    $('.news-item').first().after('<div class="h4 homepage-group-title">Další prodejny</div>')
}

if($('.type-post').length){
    if($('.usp').length){
        if (sessionStorage.HomepageUsp) {
            $('.usp').html(sessionStorage.HomepageUsp);
        } else {
            $.ajax({
                type: "GET",
                dataType: "html",
                url: "/",
                success: function(e) {
                    var a = shoptet.common.createDocumentFromString(e),
                        t = $(a).find(".usp");
                    if (t) {
                        $(".usp").html(t.html());
                        sessionStorage.HomepageUsp = t.html();
                    
                    } else {
                        console.warn('Prvek .usp není v odpovědi nalezen.');
                    }
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    console.error('Chyba při načítání blogu:', textStatus, errorThrown);
                },
               
            })
        }
    }

    if($('.nextStore').length){
        if (sessionStorage.nextStore) {
            $('.nextStore').append(sessionStorage.nextStore);
            $('.nextStore .news-item').each(function() {
                $(this).find('img').attr('src', $(this).attr('data-src'))
              //  $(this).find('.text').append('<a href="'+$(this).find('.title').attr('href')+'" class="absolutePosition"></a>')
            });
            $('.nextStore .news-item').each(function(){
                if($(this).find('.title').attr('href') === document.location.pathname){
                    $(this).hide()
                }
            })
        } else {
            $.ajax({
                type: "GET",
                dataType: "html",
                url: "/prodejny/",
                success: function(e) {
                    var a = shoptet.common.createDocumentFromString(e),
                        t = $(a).find(".news-wrapper");
                    if (t) {
                        var newsItems = t.find('.news-item');
                        newsItems.each(function() {
                            var imgElement = $(this).find('img');
                            var dataSrc = imgElement.attr('data-src');
                            var href = $(this).find('.title').attr('href');
                            
                            if (dataSrc) {
                                imgElement.attr('src', dataSrc);
                            }
                            if(map[href]) {
                                $(this).find('.text').attr('style', 'background-image:url("' + map[href] + '")');
                            }
                            
                            var linkHref = $(this).find('.title').attr('href');
                            if (linkHref) {
                                $(this).find('.text').append('<a href="' + linkHref + '" class="absolutePosition"></a>');
                            }
                        });
                        $(".nextStore").append(t.html());
                        sessionStorage.nextStore = t.html();
                    } else {
                        console.warn('Prvek nextStore není v odpovědi nalezen.');
                    }
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    console.error('Chyba při načítání blogu:', textStatus, errorThrown);
                },
               
               
            }).done(function(){
                $('.nextStore .news-item').each(function(){
                    if($(this).find('.title').attr('href') === document.location.pathname){
                        $(this).hide()
                    }
                })
            })
           
        }
        
        
    }
}